import { call, put, takeLatest, all } from "redux-saga/effects";
import { toastr } from "react-redux-toastr";
import { showAlert } from "../../utility/alertHelper";

import {
  LOAD_DASHBOARD_DETAILS,
  LOAD_DASHBOARD_DETAILS_SUCCEEDED,
  LOAD_DASHBOARD_DETAILS_FAILED,
  LOAD_DASHBOARD_GRAPH_DETAILS_SUCCEEDED,
  LOAD_DASHBOARD_GRAPH_DETAILS_FAILED,
  LOAD_DASHBOARD_GRAPH_DETAILS,
  GLOBAL_AVAILABLE_CREDITS,
  BLOCKED_CREDITS
} from "../../common/constants";

import * as api from "../../services/dashboard";
import history from "../../utility/history";

// function* loginSaga() {

//Worker saga
function* loadDashboardDetails(action) {
  try {
    const result = yield call(api.loadDashboard, action.dashboardInfo);

    //Write redirection logic here

    if (result.success) {
      if(!isNaN(result.available_credits)){
        yield put({
          type:GLOBAL_AVAILABLE_CREDITS,
          available_credits: result.available_credits
        })
      }
      if(!isNaN(result.blockedcredits)) {
        yield put({
          type: BLOCKED_CREDITS,
          blockedcredits: result.blockedcredits
        })
      }
      yield put({
        type: LOAD_DASHBOARD_DETAILS_SUCCEEDED,
        dashboardInfo: result.result
      });
    } else {
      showAlert(result.msg);
    }
  } catch (error) {
    yield put({
      type: LOAD_DASHBOARD_DETAILS_FAILED,
      args: {
        message: error.message
      }
    });
  }
}

//Worker saga
function* loadDashboardGrpahDetails(action) {
  try {
    const result = yield call(api.loadDashboardGraph, action.graphInput);

    if (result.success) {
      yield put({
        type: LOAD_DASHBOARD_GRAPH_DETAILS_SUCCEEDED,
        graphInfo: {
          ...result.graphInfo,
          frequency: action.graphInput.frequency
        }
      });
    } else {
      showAlert(result.msg);
    }
  } catch (error) {
    yield put({
      type: LOAD_DASHBOARD_GRAPH_DETAILS_FAILED,
      args: {
        message: error.message
      }
    });
  }
}

// listener Saga
function* loadDashboard() {
  yield takeLatest(LOAD_DASHBOARD_DETAILS, loadDashboardDetails);
}

// listener Saga
function* loadDashboardGraph() {
  yield takeLatest(LOAD_DASHBOARD_GRAPH_DETAILS, loadDashboardGrpahDetails);
}

//saga composition
//yield[call(onLogin)];
//}

export default function* dashboardSaga() {
  yield [loadDashboard(), loadDashboardGraph()];
}



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/sagas.js